module.exports = __webpack_public_path__ + "img/Solar-Drying-Solutions-650x340.e26da229.png";